/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: cf261779a26761ab921bf1fc2965ef5e61f518e749253553ad99cc41c76f2f04
 */
import {
  base_colorAlert,
  cta_alertButtonBackground,
  cta_alertButtonBackgroundHover,
  cta_alertButtonBorder,
  cta_alertButtonSecondaryBackground,
  cta_alertButtonSecondaryBackgroundHover,
  cta_buttonPrimaryBackground,
  cta_buttonPrimaryBackgroundHover,
  cta_buttonPrimaryBorder,
  cta_buttonPrimaryText,
  cta_buttonSecondaryBackground,
  cta_buttonSecondaryBackgroundHover,
  cta_buttonSecondaryBorder,
  cta_buttonSecondaryText,
  cta_linkTextPrimary,
  cta_linkTextPrimaryHover,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import {
  button_hGapSpacing,
  button_hSpacing,
  button_vSpacing,
  cornerRadius,
  spacing,
} from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_size_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  align-items: center;
  border-radius: ${cornerRadius};
  cursor: pointer;
  display: inline-flex;
  font-family: ${font_family_weight_regular};
  font-size: ${font_size_md};
  font-family: ${font_family_weight_medium};
  gap: ${button_hGapSpacing};
  height: ${spacing(10)};
  justify-content: center;
  line-height: 18px;
  padding-block: ${button_vSpacing};
  padding-inline: ${button_hSpacing};
  transition: all 150ms ease;

  &.dropShadow {
  }

  &.default {
    background: ${cta_buttonPrimaryBackground};
    border-color: ${cta_buttonPrimaryBorder};
    border-style: solid;
    border-width: 2px;
    color: ${cta_buttonPrimaryText};

    &:hover {
      background: ${cta_buttonPrimaryBackgroundHover};
    }

    &.disabled, &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }

  &.inline {
    background: transparent;
    border: none;
    border-radius: 0;
    color: ${cta_linkTextPrimary};
    height: auto;
    padding-block: 0;
    padding-inline: 0;

    &:hover {
      color: ${cta_linkTextPrimaryHover};
    }

    &.disabled, &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }

  &.inlineMuted {
    background: transparent;
    border: none;
    border-radius: 0;
    color: ${text_colorTextSecondary};
    height: auto;
    padding-block: 0;
    padding-inline: 0;

    &:hover {
      color: ${text_colorTextPrimary};
    }

    &.disabled, &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }

  &.inlineSevere {
    background: transparent;
    border: none;
    border-radius: 0;
    color: ${base_colorAlert};
    height: auto;
    padding-block: 0;
    padding-inline: 0;

    &:hover {
      color: ${cta_alertButtonBackgroundHover};
    }

    &.disabled, &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }

  &.noShell {
    background: transparent;
    border-color: transparent;
    border-style: solid;
    border-width: 1px;
    color: ${cta_buttonSecondaryText};

    &:hover {
      background: ${cta_buttonSecondaryBackgroundHover};
      border-color: ${cta_buttonSecondaryBorder};
    }

    &.disabled, &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }

  &.secondary {
    background: ${cta_buttonSecondaryBackground};
    border-color: ${cta_buttonSecondaryBorder};
    border-style: solid;
    border-width: 1px;
    color: ${cta_buttonSecondaryText};

    &:hover {
      background: ${cta_buttonSecondaryBackgroundHover};
    }

    &.disabled, &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }

  &.severe {
    background: ${cta_alertButtonBackground};
    border-color: ${cta_alertButtonBorder};
    border-style: solid;
    border-width: 2px;
    color: ${cta_buttonPrimaryText};

    &:hover {
      background: ${cta_alertButtonBackgroundHover};
    }

    &.disabled, &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }

  &.severeSecondary {
    background: ${cta_alertButtonSecondaryBackground};
    border-color: ${cta_buttonSecondaryBorder};
    border-style: solid;
    border-width: 1px;
    color: ${base_colorAlert};

    &:hover {
      background: ${cta_alertButtonSecondaryBackgroundHover};
    }

    &.disabled, &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }

  &.dropShadow.default, &.dropShadow.severe {
    box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.15);
  }

  &.dropShadow.secondary, &.dropShadow.severeSecondary {
    box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.1);
  }

  &.inline, &.inlineMuted, &.inlineSevere {
    border-radius: 0;
    height: auto;
    padding-block: 0;
    padding-inline: 0;
  }
`
